import React from 'react';
import { Menu, Dropdown, Avatar } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';

import AvatarDefault from 'assets/PS_UserAvatarDefault.svg';
import useCurrentUserInfo from 'utils/CustomHooks/useCurrentUserInfo';
import { logoutUser } from 'utils/user/userAuth';

import './styles.scss';

const HeaderAccount = () => {
  const userInfo = useCurrentUserInfo();
  const menu = (
    <Menu>
      <Menu.Item onClick={() => logoutUser()}>
        <LogoutOutlined /> Logout
      </Menu.Item>
    </Menu>
  );
  if (userInfo) {
    return (
      <section className="HeaderAccount">
        <Dropdown overlay={menu} placement="bottomRight">
          <span className="pps-header-account">
            <Avatar
              size={26}
              icon={<img src={AvatarDefault} alt={userInfo.firstName} />}
            />
            <span className="pps-header-account__username">
              {userInfo.firstName}
            </span>
          </span>
        </Dropdown>
      </section>
    );
  } else {
    return null;
  }
};

export default HeaderAccount;
